import React from 'react';
import Typography from '@material-ui/core/Typography';

import { PROJECT_STATUS } from '../../interfaces/project';
import { useWideStatusBarStyles } from './styles';

const statusProgress = (status: PROJECT_STATUS): number => {
  switch (status) {
    case PROJECT_STATUS.DRAFT:
      return 1;
    case PROJECT_STATUS.TEST:
      return 2;
    case PROJECT_STATUS.REVIEW:
      return 3;
    case PROJECT_STATUS.LIVE:
      return 4;
    default:
      return 0;
  }
};

const StatusBarWide: React.FC<{ status: PROJECT_STATUS }> = ({ status }) => {
  const classes = useWideStatusBarStyles();
  const statusIndex = statusProgress(status);

  return (
    <div className={classes.row}>
      <div className={classes.container}>
        <div className={classes.step}>
          <div className={`${classes.bullet} hasNext completed`}>
            <Typography variant="body2">Draft</Typography>
          </div>
        </div>
        <div className={classes.step}>
          <div className={`${classes.bullet} hasNext ${statusIndex >= 2 ? 'completed' : ''}`}>
            <Typography variant="body2">Testing</Typography>
          </div>
        </div>
        <div className={classes.step}>
          <div className={`${classes.bullet} hasNext ${statusIndex >= 3 ? 'completed' : ''}`}>
            <Typography variant="body2">Review</Typography>
          </div>
        </div>
        <div className={classes.step}>
          <div className={`${classes.bullet} ${statusIndex >= 4 ? 'completed' : ''}`}>
            <Typography variant="body2">Production</Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusBarWide;
